import { Directive, ElementRef, HostListener, Renderer2 } from "@angular/core";

@Directive({
    selector: "[appCardType]",
    standalone: false
})
export class CardTypeDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener("input")
  onInputChange() {
    const input = this.el.nativeElement;
    const cardType = this.detectCardType(input.value);
    return cardType;
  }

  private detectCardType(value: string): string {
    // Add your card type detection logic here
    // Example: detect Visa, Mastercard, Verve, etc.
    if (value.startsWith("4")) {
      return "visa";
    } else if (value.startsWith("5")) {
      if (
        value.startsWith("5061") ||
        value.startsWith("5062") ||
        value.startsWith("5063") ||
        value.startsWith("5064") ||
        value.startsWith("5065")
      ) {
        return "verve";
      } else {
        return "mastercard";
      }
    } else {
      return "";
    }
  }
}
